import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { AuthorizationService } from 'src/app/services/authorization/authorization.service';
import { DataService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class AuthZGuard implements CanActivate {
    constructor(private authZ: AuthorizationService,
                private router: Router,
                private cookieService: CookieService,
                private dataService: DataService) {
    }

    canActivatePermission(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return route.data ? this.hasAccess(route.data['permissions']) : of(false);
    }

    /**
     * @Override AuthZGuard.canActivate in order to...
     * - make use of cookie 'adminOn' flag to allow ADMINs to view in admin/non-admin mode.
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable((obs) => {
            this.dataService.getUserInfo().subscribe( {
                next: (ready) => {
                    this.canActivatePermission(route, state).subscribe(canActivate => {
                        obs.next(canActivate && this.cookieService.get('adminOn') === 'true');
                        obs.complete();
                    })
                },
            });
        });
    }

    private hasAccess(permissions): Observable<boolean> {
        return new Observable((obs) => {
            this.authZ.hasAccess([].concat(permissions)).subscribe((access) => {
                if (access) {
                    obs.next(true);
                } else {
                    this.router.navigateByUrl('/restricted');
                    obs.next(false);
                }
                obs.complete();
            });
        });
    }
}
